import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchResults } from '../searchResults';
import { Owner } from './owner';

@JsonObject('OwnerSearchResults')
export class OwnerSearchResults extends SearchResults {
    @JsonProperty('results', [Owner])
    results: Owner[] = [];
}
